export default __webpack_public_path__ + "static/FbTestimonial7-2268f6453818b28b0f33a2f6235199a8.jpeg";